import { apiGet } from '../../../fetch/apiService';

export function getMembers() {
	return apiGet('members', { basic: true });
}
